/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationType } from './NotificationType';
import {
    NotificationTypeFromJSON,
    NotificationTypeFromJSONTyped,
    NotificationTypeToJSON,
    NotificationTypeToJSONTyped,
} from './NotificationType';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    clickTarget: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDto
     */
    isRead: boolean;
    /**
     * 
     * @type {UserDto}
     * @memberof NotificationDto
     */
    recipient?: UserDto | null;
    /**
     * Comma-separated list of target roles (only for role-based notifications)
     * @type {string}
     * @memberof NotificationDto
     */
    targetRoles?: string | null;
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationDto
     */
    type: NotificationType;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    organizationId: string;
    /**
     * 
     * @type {Date}
     * @memberof NotificationDto
     */
    createdAt: Date;
}



/**
 * Check if a given object implements the NotificationDto interface.
 */
export function instanceOfNotificationDto(value: object): value is NotificationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('clickTarget' in value) || value['clickTarget'] === undefined) return false;
    if (!('isRead' in value) || value['isRead'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function NotificationDtoFromJSON(json: any): NotificationDto {
    return NotificationDtoFromJSONTyped(json, false);
}

export function NotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'clickTarget': json['clickTarget'],
        'isRead': json['isRead'],
        'recipient': json['recipient'] == null ? undefined : UserDtoFromJSON(json['recipient']),
        'targetRoles': json['targetRoles'] == null ? undefined : json['targetRoles'],
        'type': NotificationTypeFromJSON(json['type']),
        'organizationId': json['organizationId'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function NotificationDtoToJSON(json: any): NotificationDto {
    return NotificationDtoToJSONTyped(json, false);
}

export function NotificationDtoToJSONTyped(value?: NotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'message': value['message'],
        'clickTarget': value['clickTarget'],
        'isRead': value['isRead'],
        'recipient': UserDtoToJSON(value['recipient']),
        'targetRoles': value['targetRoles'],
        'type': NotificationTypeToJSON(value['type']),
        'organizationId': value['organizationId'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

